import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Assignment from 'inbox/assignment'
import { IconButton } from 'shared/ui'

const tooltipLabel = (label, bindHotKey) => {
  const key = bindHotKey ? ' [a]' : ''
  if (label) return `Reassign (${label})${key}`
  return `Assign${key}`
}

const WithIconState = ({
  assignment,
  assignmentLabel,
  bgColor,
  bindHotKey,
  children,
  className,
  onClick,
  size,
  iconSize = 14,
  tooltipPosition,
}) => {
  const isAssigned = Boolean(assignment) || Boolean(assignmentLabel)
  const label = isAssigned
    ? assignmentLabel || assignment.agentName || assignment.groupName
    : undefined

  return (
    <React.Fragment>
      <IconButton
        bgColor={bgColor}
        className={cn(className, { assigned: isAssigned })}
        key="badge"
        label={label}
        name="chatBubbleUser"
        onClick={onClick}
        size={size}
        iconSize={iconSize}
        svg
        tooltip={tooltipLabel(label, bindHotKey)}
        tooltipPosition={tooltipPosition}
      />
      {children}
    </React.Fragment>
  )
}

WithIconState.propTypes = {
  assignment: Assignment.t,
  bindHotKey: PropTypes.bool,
  size: PropTypes.string,
  tooltipPosition: PropTypes.string,
}

WithIconState.defaultProps = {
  assignment: undefined,
  bindHotKey: false,
  size: 'medium',
  tooltipPosition: 'bottom',
}

export default WithIconState
